module.exports = __webpack_public_path__ + "img/labor-file-icon-image.3b628547.png";